import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	assistantDefaultMessageContent: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	durationButtonsContainer: {
		display: 'flex',
		gap: THEME.spacing.md,
	},
	contentCalendarGenerationPreviewConfirmationText: {
		color: THEME.colors.text.main,
		fontSize: 14,
	},
});
